export default function ProductGrid() {
  const products = [
    {
      name: 'ELCO AEROTOP G',
      category: 'Pompe à chaleur air-eau',
      power: '6-16 kW',
      image: 'https://readdy.ai/api/search-image?query=Premium%20ELCO%20AEROTOP%20G%20heat%20pump%20outdoor%20unit%20in%20pristine%20white%20finish%20with%20modern%20geometric%20design%2C%20professional%20product%20photography%20against%20clean%20white%20background%20showing%20sleek%20compact%20housing%20with%20ventilation%20grilles%20and%20ELCO%20branding%2C%20high-end%20residential%20heating%20equipment%20with%20minimalist%20aesthetic&width=800&height=600&seq=elco-aerotop-g&orientation=portrait',
      features: ['COP jusqu\'à 4.8', 'Fonctionnement jusqu\'à -20°C', 'Niveau sonore ultra-bas 35 dB(A)', 'Compatible chauffage au sol', 'Garantie 5 ans constructeur'],
      specs: { efficiency: 'A+++', refrigerant: 'R32 écologique', control: 'Régulation ELCO THISION' }
    },
    {
      name: 'ELCO AEROTOP T',
      category: 'Pompe à chaleur air-eau compacte',
      power: '4-12 kW',
      image: 'https://readdy.ai/api/search-image?query=Compact%20ELCO%20AEROTOP%20T%20heat%20pump%20unit%20in%20elegant%20white%20casing%20with%20streamlined%20modern%20design%2C%20professional%20studio%20photography%20on%20white%20background%20showcasing%20premium%20build%20quality%20with%20integrated%20controls%20and%20efficient%20ventilation%20system%2C%20Swiss-made%20residential%20heating%20solution%20with%20contemporary%20styling&width=800&height=600&seq=elco-aerotop-t&orientation=portrait',
      features: ['Design ultra-compact', 'COP jusqu\'à 4.6', 'Installation simplifiée', 'Idéal rénovation', 'Garantie 5 ans constructeur'],
      specs: { efficiency: 'A++', refrigerant: 'R32 écologique', control: 'Commande intuitive' }
    },
    {
      name: 'ELCO TRIGON XXL',
      category: 'Pompe à chaleur géothermique',
      power: '8-24 kW',
      image: 'https://readdy.ai/api/search-image?query=High-end%20ELCO%20TRIGON%20XXL%20geothermal%20heat%20pump%20indoor%20unit%20with%20sophisticated%20silver%20and%20black%20finish%2C%20professional%20product%20photography%20showing%20advanced%20control%20panel%20with%20digital%20display%2C%20premium%20technical%20equipment%20with%20robust%20construction%20and%20modern%20industrial%20design%20against%20neutral%20background&width=800&height=600&seq=elco-trigon-xxl&orientation=portrait',
      features: ['COP jusqu\'à 5.2', 'Rendement exceptionnel', 'Eau chaude sanitaire intégrée', 'Technologie inverter', 'Garantie 7 ans constructeur'],
      specs: { efficiency: 'A+++', refrigerant: 'R407C', control: 'Régulation intelligente' }
    },
    {
      name: 'ELCO AQUATOP T',
      category: 'Pompe à chaleur eau-eau',
      power: '10-20 kW',
      image: 'https://readdy.ai/api/search-image?query=Professional%20ELCO%20AQUATOP%20T%20water-source%20heat%20pump%20in%20sleek%20metallic%20finish%20with%20modern%20control%20interface%2C%20detailed%20product%20photography%20highlighting%20premium%20construction%20quality%20with%20visible%20heat%20exchanger%20components%20and%20digital%20monitoring%20system%2C%20advanced%20Swiss%20heating%20technology%20with%20industrial-grade%20design&width=800&height=600&seq=elco-aquatop-t&orientation=portrait',
      features: ['COP jusqu\'à 5.0', 'Utilisation nappe phréatique', 'Très haute efficacité', 'Fonctionnement silencieux', 'Garantie 6 ans constructeur'],
      specs: { efficiency: 'A+++', refrigerant: 'R134a', control: 'Système de gestion avancé' }
    },
    {
      name: 'ELCO AEROTOP HYBRID',
      category: 'Système hybride PAC + Chaudière',
      power: '6-14 kW + 24 kW',
      image: 'https://readdy.ai/api/search-image?query=Innovative%20ELCO%20AEROTOP%20HYBRID%20system%20combining%20heat%20pump%20and%20condensing%20boiler%20in%20unified%20white%20housing%2C%20professional%20photography%20showing%20dual-technology%20heating%20solution%20with%20integrated%20controls%20and%20premium%20finish%2C%20modern%20Swiss%20hybrid%20heating%20system%20with%20space-saving%20design%20against%20clean%20background&width=800&height=600&seq=elco-hybrid&orientation=portrait',
      features: ['Double technologie optimisée', 'Basculement automatique', 'Économies maximales', 'Sécurité grand froid', 'Garantie 5 ans constructeur'],
      specs: { efficiency: 'A++ hybride', refrigerant: 'R32 + Gaz naturel', control: 'Gestion intelligente' }
    },
    {
      name: 'ELCO AEROTOP S',
      category: 'Pompe à chaleur split',
      power: '5-14 kW',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20ELCO%20AEROTOP%20S%20split%20heat%20pump%20with%20separate%20outdoor%20and%20indoor%20units%20in%20pristine%20white%20finish%2C%20professional%20product%20photography%20showing%20compact%20outdoor%20compressor%20unit%20and%20sleek%20indoor%20hydraulic%20module%20with%20digital%20display%2C%20premium%20Swiss%20heating%20technology%20with%20modular%20design&width=800&height=600&seq=elco-aerotop-s&orientation=portrait',
      features: ['Installation flexible', 'COP jusqu\'à 4.7', 'Module intérieur compact', 'Faible encombrement', 'Garantie 5 ans constructeur'],
      specs: { efficiency: 'A++', refrigerant: 'R32 écologique', control: 'Régulation ELCO' }
    }
  ];

  return (
    <section id="produits" className="py-24 bg-gray-900">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-base font-semibold leading-7 text-orange-400">Notre Gamme ELCO</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Pompes à Chaleur Haute Performance
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-400">
            Solutions complètes pour le chauffage et l'eau chaude sanitaire. Installation professionnelle et mise en service.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {products.map((product, index) => (
            <div key={index} className="bg-gray-800 rounded-2xl border border-gray-700 overflow-hidden hover:border-orange-500/40 transition-all">
              <div className="relative w-full h-80 bg-gray-700">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  {product.specs.efficiency}
                </div>
              </div>
              <div className="p-6">
                <div className="mb-4">
                  <p className="text-sm text-orange-400 font-semibold mb-1">{product.category}</p>
                  <h3 className="text-xl font-bold text-white mb-2">{product.name}</h3>
                  <p className="text-sm text-gray-400">Puissance: {product.power}</p>
                </div>
                <ul className="space-y-2 mb-6">
                  {product.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-check-line text-orange-400 mt-1 mr-2 flex-shrink-0"></i>
                      <span className="text-sm text-gray-300">{feature}</span>
                    </li>
                  ))}
                </ul>
                <div className="border-t border-gray-700 pt-4 mb-6">
                  <div className="grid grid-cols-2 gap-3 text-sm">
                    <div>
                      <p className="text-gray-500">Fluide</p>
                      <p className="font-semibold text-gray-200">{product.specs.refrigerant}</p>
                    </div>
                    <div>
                      <p className="text-gray-500">Contrôle</p>
                      <p className="font-semibold text-gray-200">{product.specs.control}</p>
                    </div>
                  </div>
                </div>
                <a href="#contact" className="block w-full text-center rounded-full bg-orange-500 px-6 py-3 text-sm font-semibold text-white hover:bg-orange-600 transition-all whitespace-nowrap cursor-pointer">
                  Demander un devis
                </a>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-12 bg-gray-800 rounded-2xl p-8 border border-orange-500/20">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-lg flex-shrink-0">
              <i className="ri-information-line text-2xl text-white"></i>
            </div>
            <div>
              <h3 className="text-xl font-bold text-white mb-2">Installation complète</h3>
              <p className="text-gray-400 leading-relaxed mb-4">
                Nos installations incluent la pompe à chaleur ELCO, l'installation complète par nos techniciens certifiés, la mise en service, les réglages optimaux et la formation à l'utilisation. Garantie constructeur ELCO incluse.
              </p>
              <p className="text-gray-400 leading-relaxed">
                <strong className="text-white">Subventions disponibles:</strong> Profitez des aides cantonales genevoises (jusqu'à CHF 10'000.-) et du programme fédéral de promotion des énergies renouvelables. Nous vous accompagnons dans vos démarches administratives.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
